import { useCallback, useState } from "react"

import type { Agent } from "@/types"

export interface AgentPublicationResult {
  agent: Agent
  versionNumber?: number
}

// Keep publication metadata separate from editor input props so publishing
// does not reset a dirty form or the selected historical version.
export const useAgentPublicationState = (agent?: Agent) => {
  const [results, setResults] = useState<
    Record<string, AgentPublicationResult>
  >({})
  const recordPublication = useCallback((result: AgentPublicationResult) => {
    setResults((previous) => ({ ...previous, [result.agent.id]: result }))
  }, [])
  const result = agent ? results[agent.id] : undefined
  // A newly fetched/saved agent supersedes our local publication result.
  const isCurrent = !!result && result.agent === agent

  return {
    publishedVersionNumber: isCurrent
      ? result.versionNumber
      : agent?.publishedVersionNumber,
    hasPublishedVersion: isCurrent
      ? result.versionNumber != null
      : agent?.publishedVersionNumber != null,
    recordPublication,
  }
}

export const isPublicationActionDisabled = ({
  isProcessing,
  historyUnavailable,
  dirty,
  isPublished,
}: {
  isProcessing: boolean
  historyUnavailable: boolean
  dirty: boolean
  isPublished: boolean
}) => isProcessing || historyUnavailable || (dirty && !isPublished)
